<template>
    <div>
        <transition name="boardal">
          <div class="boardal">
              <div class="boardal__mask" v-if="hasMask" @click="clickMask"></div>
              <div class="boardal__wrapper">
                <slot></slot>
                <div class="boardal__x" v-if="hasX" @click="clickX">&times;</div>
              </div>
          </div>
        </transition>
    </div>
</template>

<script>
    export default {
name: 'boardal',
props: [
    'hasX',
    'hasMask',
    'canClickMask'
  ],
  methods: {
    clickX: function(){
      this.$emit('toggle')
    },
    clickMask: function(){
      if(this.canClickMask) {
        this.$emit('toggle')
      }
    }
  }
    }
</script>

<style lang="scss" scoped>


.boardal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  &__mask {
    background: rgba(#000,.65);
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  &__wrapper {
    position: relative;
    width: 65vw;
    max-width: 60em;
    min-width: 23em;
    max-height: 83vh;
    height: 40em;
    background: #fff;
    color: #333;
    display: flex;
    flex-direction: var(--cross, column);
    border-radius: 0.2em;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 20%), 0 1em 2em -1em;
    top: 35px;
  }
  &__x {
    cursor: pointer;
    font-size: 2em;
    line-height: .5;
    opacity: .15;
    &:hover {
      opacity: .65;
    }
  }
  &-enter-active,
  &-leave-active {
    transition: opacity .25s
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}

// media queries for common device breakpoints 

//Galaxy Fold //
@media only screen and (min-device-width : 270px) and (max-device-width : 280px) {
.boardal__wrapper {
  min-width: 18em;
}
}
//
@media only screen and (min-device-width : 281px) and (max-device-width : 320px) {
.boardal__wrapper {
  min-width: 19em;
}
}
//iPhone 5 //
@media only screen and (min-device-width : 321px) and (max-device-width : 359px) and (orientation : portrait)  {
.boardal__wrapper {
  min-width: 22em;
}
}
//Galaxy S5/S8/Moto S4 //
@media only screen and (min-device-width : 360px) and (max-device-width : 374px) and (orientation : portrait)  {
.boardal__wrapper {
  min-width: 23em;
}
}
//iPhone 6/7/8/X/11Pro/12 Mini //
@media only screen and (min-device-width : 375px) and (max-device-width : 389px) and (orientation : portrait)  {
.boardal__wrapper {
  min-width: 24em;
}
}
//iPhone 12/12Pro //
@media only screen and (min-device-width : 390px) and (max-device-width : 413px) and (orientation : portrait)  {
.boardal__wrapper {
  min-width: 26em;
}
}
//iPhone 6/7/8 Plus/11 //
@media only screen and (min-device-width : 414px) and (max-device-width : 440px) and (orientation : portrait)  {
.boardal__wrapper {
  min-width: 27em;
}
}

</style>